module.exports = __webpack_public_path__ + "static/img/10.9bd7980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/10.png
// module id = sDag
// module chunks = 0